module.exports = __webpack_public_path__ + "img/logo.38da3fa6.svg";